import Immutable from 'immutable';

export default Immutable.Record({
  index: 0,
  time: 0
});


/** WEBPACK FOOTER **
 ** ./src/models/AudioPosition.es6
 **/